import EDC from '../../../shared/globals';

EDC.Animations.Shake = function (scene, notes) {
  this.scene = scene;
  this.notes = notes;
};

EDC.Animations.Shake.prototype.start = function () {
  this.notes.map((x) => {
    x.angle = -3;
    return true;
  }, this);
  if (!this.stopped) {
    this.scene.tweens.add({
      targets: this.notes.map((note) => {
        if (note.input.enabled) {
          return note;
        }
        return true;
      }),
      angle: 3,
      duration: 60,
      ease: 'Sine.easeInOut',
      repeat: 3,
      yoyo: true,
      onComplete: this.getRandomTime(this.notes),
    });
  }
};

EDC.Animations.Shake.prototype.getRandomTime = function () {
  this.notes.map((x) => {
    x.angle = 0;
    return true;
  }, this);
  const rndTime = Math.round(Math.random() * 15000);
  this.scene.time.addEvent({ delay: rndTime, callback: this.start, callbackScope: this });
};

EDC.Animations.Shake.prototype.stop = function () {
  this.stopped = true;
};
export default EDC.Animations.Shake;
